<template>
  <el-drawer
    title="主题设置"
    :visible.sync="drawerVisible"
    direction="rtl"
    size="320px"
    append-to-body
    @open="syncForm"
  >
    <div class="theme-settings">
      <div class="theme-settings__section">
        <div class="theme-settings__title">预设主题</div>
        <div class="theme-settings__presets">
          <el-button
            v-for="(preset, key) in presetThemes"
            :key="key"
            size="mini"
            :type="activePreset === key ? 'primary' : 'default'"
            @click="applyPreset(key)"
          >
            {{ preset.label }}
          </el-button>
        </div>
      </div>

      <div class="theme-settings__section">
        <div class="theme-settings__title">自定义颜色</div>
        <el-form label-width="88px" size="small">
          <el-form-item label="侧边栏背景">
            <el-color-picker v-model="form.sidebarBg" @change="handleChange" />
          </el-form-item>
          <el-form-item label="子菜单背景">
            <el-color-picker v-model="form.sidebarSubBg" @change="handleChange" />
          </el-form-item>
          <el-form-item label="菜单文字">
            <el-color-picker v-model="form.sidebarText" @change="handleChange" />
          </el-form-item>
          <el-form-item label="菜单激活色">
            <el-color-picker v-model="form.sidebarActive" @change="handleChange" />
          </el-form-item>
          <el-form-item label="顶部背景">
            <el-color-picker v-model="form.headerBg" @change="handleChange" />
          </el-form-item>
          <el-form-item label="顶部边框">
            <el-color-picker v-model="form.headerBorder" @change="handleChange" />
          </el-form-item>
          <el-form-item label="顶部文字">
            <el-color-picker v-model="form.headerText" @change="handleChange" />
          </el-form-item>
        </el-form>
      </div>

      <div class="theme-settings__footer">
        <el-button size="small" @click="handleReset">恢复默认</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { DEFAULT_THEME, PRESET_THEMES } from '@/config/theme'

export default {
  name: 'ThemeSettings',
  data() {
    return {
      form: { ...DEFAULT_THEME },
      presetThemes: PRESET_THEMES,
    }
  },
  computed: {
    ...mapState('theme', ['theme', 'settingsVisible']),
    drawerVisible: {
      get() {
        return this.settingsVisible
      },
      set(val) {
        this.SET_SETTINGS_VISIBLE(val)
      },
    },
    activePreset() {
      return Object.keys(PRESET_THEMES).find((key) => {
        const preset = PRESET_THEMES[key].theme
        return Object.keys(preset).every((field) => preset[field] === this.theme[field])
      }) || ''
    },
  },
  methods: {
    ...mapMutations('theme', ['SET_THEME', 'RESET_THEME', 'APPLY_PRESET', 'SET_SETTINGS_VISIBLE']),
    syncForm() {
      this.form = { ...this.theme }
    },
    handleChange() {
      const nextTheme = { ...this.form }
      const hasEmpty = Object.values(nextTheme).some((value) => !value)
      if (hasEmpty) {
        return
      }
      this.SET_THEME(nextTheme)
    },
    applyPreset(key) {
      this.APPLY_PRESET(key)
      this.syncForm()
    },
    handleReset() {
      this.RESET_THEME()
      this.syncForm()
      this.$message.success('已恢复默认主题')
    },
  },
}
</script>

<style lang="less" scoped>
.theme-settings {
  padding: 0 4px 20px;
  &__section {
    margin-bottom: 24px;
  }
  &__title {
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }
  &__presets {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  &__footer {
    padding-top: 8px;
    border-top: 1px solid #ebeef5;
  }
}
</style>
